var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconFrontpageMedium = function SvgIconFrontpageMedium(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".medium-a,.b{fill:currentColor;}.medium-b{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.444)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "medium-a",
    d: "M9.942,7.21A8.694,8.694,0,1,0,16.1,9.768,8.728,8.728,0,0,0,9.942,7.21Zm13.837.515c-2.386,0-4.325,3.675-4.325,8.213s1.938,8.213,4.325,8.213,4.336-3.675,4.336-8.213h0C28.115,11.4,26.176,7.725,23.779,7.725Zm6.722.852c-.84,0-1.513,3.294-1.513,7.361s.683,7.361,1.524,7.361,1.524-3.294,1.524-7.361-.683-7.361-1.524-7.361Z",
    transform: "translate(-0.202 0.868)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "medium-b",
    width: 34,
    height: 34,
    transform: "translate(-0.444)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFrontpageMedium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-frontpage-medium.66be63fd.svg";
export { ForwardRef as ReactComponent };